import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const projectPlacementsRoutes = [
  {
    path: 'placements',
    meta: {
      routeName: {
        segmentName: () => translation.tr('Placements')
      },
      permissions: ['READ_PLACEMENTS']
    },
    component: NestedRouteComponent,
    children: [
      {
        path: '',
        name: 'placementsList',
        component: wrapLegacyRoute('placementsController', 'list')
      },
      {
        path: 'create',
        name: 'placementCreate',
        component: wrapLegacyRoute('placementsController', 'create')
      },
      {
        path: ':placementId(\\d+)',
        component: NestedRouteComponent,
        children: [
          {
            path: '',
            name: 'placementDetails',
            component: wrapLegacyRoute('placementsController', 'details')
          }
        ]
      }
    ]
  }
];

export default projectPlacementsRoutes;
